"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecoreMarquee;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("../../elements/other/headline-lockup/index.js"));
var _react2 = require("@linaria/react");
var _filterNav = _interopRequireDefault(require("../../elements/other/filter-nav"));
var _recoreCard = _interopRequireDefault(require("./recore-card"));
var _marquee = _interopRequireDefault(require("../recore-marquee-2/marquee"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const cardBreakpoint = _patternLibraryUtils.deviceMax.tablet; // Breakpoint for compact card layout (i.e large card above 2 smaller cards)
const navBreakpoint = _patternLibraryUtils.deviceMax.laptopLg; // Breakpoint for compact navigation layout (i.e. horizontal filters above cards)

const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c15tbf36"
});
const MarqueeContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarqueeContainer",
  class: "pl-m1d6y1m3",
  vars: {
    "m1d6y1m3-0": [({
      backgroundColor
    }) => backgroundColor ?? `${_intents.default.ux.controlFocused.backgroundColor}`]
  }
});
const HeaderContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeaderContainer",
  class: "pl-h1xlc5fa"
});
const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-nzd0hf1"
});
const RecoreCardSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RecoreCardSection",
  class: "pl-rpnirp",
  vars: {
    "rpnirp-0": [({
      cardCount
    }) => cardCount % 2 ? '18fr 16fr' : '1fr 1fr']
  }
});

/**
 * recore marquee
 *
 * @param {String} heading marquee heading
 * @param {String} headlineSize heading sizing
 * @param {Array} categories filter nav category nav
 * @param {Array} cards collection of recore cards
 */

function RecoreMarquee(props) {
  const {
    _name,
    eyebrow,
    heading,
    headlineSize = 'h3',
    headlineLineLength = 1,
    backgroundColor,
    categories = [],
    cardHeadlineSize = 'h4',
    cardTextFontSize = '1em',
    cardSets = [],
    verticalPadding = 'none',
    recoreMarqueeVersion
  } = props;
  const cardSectionRef = (0, _react.useRef)(null);
  const [cardSetIndex, setCardSetIndex] = (0, _react.useState)(0);
  const [selectedCardSet, setSelectedCardSet] = (0, _react.useState)(cardSets[0]?.cards ?? []);

  // TODO: remove this check when we roll out v2 to control, https://godaddy-corp.atlassian.net/browse/NXT-2704
  if (recoreMarqueeVersion && recoreMarqueeVersion === 2) {
    return /*#__PURE__*/_react.default.createElement(_marquee.default, props);
  }
  const handleFilterNavSelect = e => {
    function reanimateCards() {
      cardSectionRef.current.classList.remove('animate');
      // This triggers a reflow which means the styles get calculated again
      void cardSectionRef.current.offsetWidth;
      cardSectionRef.current.classList.add('animate');
    }
    categories.forEach(navButton => {
      if (e.target.id === `id-${navButton.id}`) {
        const newCardSetIndex = navButton.navId - 1;
        const newCardSet = cardSets?.[newCardSetIndex]?.cards;
        if (newCardSet && Array.isArray(newCardSet)) {
          setCardSetIndex(newCardSetIndex);
          setSelectedCardSet(newCardSet);
          reanimateCards();
          return selectedCardSet;
        }
        throw Error(`Invalid CardSet ${newCardSetIndex}`);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(Container, {
    _name: _name,
    dataCy: "recore-marquee",
    padding: "none",
    verticalMargin: "none",
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(MarqueeContainer, {
    "data-cy": "marquee-container",
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react.default.createElement(HeaderContainer, {
    "data-cy": "headline-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineSize: headlineSize,
    headlineLineLength: headlineLineLength,
    headlineTag: eyebrow ? 'h3' : 'h2',
    textAlign: "start",
    className: "recore-marquee-headline"
  }), /*#__PURE__*/_react.default.createElement(NavContainer, null, categories && /*#__PURE__*/_react.default.createElement(_filterNav.default, {
    categories: categories,
    handleAction: e => handleFilterNavSelect(e)
  }))), /*#__PURE__*/_react.default.createElement(RecoreCardSection, {
    "data-cy": "recore-card-section",
    "data-card-set": cardSetIndex + 1,
    cardCount: selectedCardSet.length,
    "data-card-count": selectedCardSet.length,
    ref: cardSectionRef
  }, selectedCardSet && Array.isArray(selectedCardSet) && selectedCardSet.map((card, i) => {
    const key = `recore-card-${i}`;
    return /*#__PURE__*/_react.default.createElement(_recoreCard.default, (0, _extends2.default)({
      key: key,
      headlineSize: cardHeadlineSize,
      textFontSize: cardTextFontSize
    }, card));
  }))));
}
RecoreMarquee.propTypes = {
  heading: _propTypes.default.string,
  headlineSize: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  headlineLineLength: _propTypes.default.number,
  backgroundColor: _propTypes.default.shape({
    rgb: _propTypes.default.string,
    intent: _propTypes.default.string
  }),
  categories: _propTypes.default.array,
  cardHeadlineSize: _propTypes.default.string,
  cardTextFontSize: _propTypes.default.string,
  cardSets: _propTypes.default.arrayOf(_propTypes.default.shape({
    cards: _propTypes.default.arrayOf(_propTypes.default.object)
  })),
  ..._patternLibraryUtils.paddingProps
};